import { productHelper } from "@lib/helpers";
import AddToCart from "@containers/Catalog/Actions/AddToCart";

const ProductPageStickyFooter = ({
  product,
  activeServices,
  westacoData,
  isWestacoDataValid,
}) => {
  const { isWestaco } = productHelper(product);

  return (
    <div>
      <AddToCart
        product={product}
        activeServices={activeServices}
        westaco={westacoData}
        disabled={isWestaco && !isWestacoDataValid}
      />
    </div>
  );
};

export default ProductPageStickyFooter;
